<template>
    <div>
        <v-simple-table class="table-layout pa-5">
            <template v-slot:default>
                <thead>
                    <tr>
                        <th>Tháng</th>
                        <th>New VIP</th>
                        <th>Gia hạn + Cross sales</th>
                        <th>Gia hạn gói</th>
                        <th>Đang VIP</th>
                        <th>VIP tích lũy</th>
                    </tr>
                </thead>
                <tbody v-if="_.isArray(accountData) && accountData.length">
                    <template v-for="(item, index) in accountData">
                        <tr :key="index">
                            <td>{{ item.month }}</td>
                            <td>{{ formatPrice(item.newVip) }}</td>
                            <td>{{ formatPrice(item.extendVip) }}</td>
                            <td>{{ formatPrice(item.extendProductVip) }}</td>
                            <td>{{ formatPrice(item.stillVip) }}</td>
                            <td>{{ formatPrice(item.accumulationVip) }}</td>
                        </tr>
                    </template>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="100">
                            <common-no-result />
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>
export default {
    props: {
        accountData: {
            type: Array,
            default: () => {[]}
        }
    }
}
</script>

<style scoped>
.table-layout tbody tr {
    height: 40px !important;
}

.table-layout th {
    font-size: 18px !important;
}

.table-layout td {
    font-size: 16px !important;
}
</style>